<div class="wrapper">
  <div class="screen-header">
    <gains-title title="DEO AI Assist"></gains-title>
  </div>
  <div class="inner-wrapper">
    <div class="left-panel" [class.collapsed]="isSidebarCollapsed">
      <!-- Sidebar Header with Branding -->
      <div class="sidebar-header">
        <deo-talking-to-selector
          *ngIf="isTalkingToEnabled && !isSidebarCollapsed"
          class="sidebar-talking-to"
          [targets]="talkingToTargets"
          [selectedId]="selectedTargetId"
          (selected$)="onTalkingToSelected($event)"
        ></deo-talking-to-selector>

        <div class="sidebar-brand" *ngIf="!isTalkingToEnabled && !isSidebarCollapsed">
          <svg-icon src="assets/icons/deo-agent-icon.svg" svgClass="brand-icon" />
          <span class="brand-text">DEO AI Assist</span>
        </div>
        <button nz-button nzType="text" class="sidebar-toggle-btn" (click)="toggleSidebar()" title="Collapse sidebar" *ngIf="!isSidebarCollapsed">
          <svg-icon src="assets/icons/sidebar-left.svg" svgClass="sidebar-toggle-icon" />
        </button>
        <button nz-button nzType="text" class="sidebar-toggle-btn" (click)="toggleSidebar()" title="Expand sidebar" *ngIf="isSidebarCollapsed">
          <svg-icon src="assets/icons/sidebar-right.svg" svgClass="sidebar-toggle-icon" />
        </button>
      </div>

      <!-- New Chat Button -->
      <div class="new-chat-section">
        <button nz-button nzType="default" (click)="createNewChat()" class="new-chat-btn">
          <svg-icon src="assets/icons/plus.svg" svgClass="plus-icon" />
          <span *ngIf="!isSidebarCollapsed">New Chat</span>
        </button>
      </div>

      <!-- Navigation Menu -->
      <div class="sidebar-nav">
        <div class="nav-item" [class.active]="activeTab === 'chats'" (click)="changeActiveTab('chats')" tabindex="0" (keydown.enter)="changeActiveTab('chats')">
          <div class="nav-icon-left">
            <svg-icon src="assets/icons/chat.svg" class="nav-icon" />
            <span *ngIf="!isSidebarCollapsed">Chats</span>
          </div>
          <svg-icon *ngIf="!isSidebarCollapsed" src="assets/icons/arrow-right.svg" class="nav-icon nav-icon-right" />
        </div>
        <div
          *ngIf="isProjectsVisible"
          class="nav-item"
          [class.active]="activeTab === 'projects'"
          (click)="changeActiveTab('projects')"
          tabindex="0"
          (keydown.enter)="changeActiveTab('projects')"
        >
          <div class="nav-icon-left">
            <svg-icon src="assets/icons/projects.svg" class="nav-icon" />
            <span *ngIf="!isSidebarCollapsed">Projects</span>
          </div>
          <svg-icon *ngIf="!isSidebarCollapsed" src="assets/icons/arrow-right.svg" class="nav-icon nav-icon-right" />
        </div>
        <div class="nav-item" [class.active]="activeTab === 'artifacts'" (click)="changeActiveTab('artifacts')" tabindex="0" (keydown.enter)="changeActiveTab('artifacts')">
          <div class="nav-icon-left">
            <svg-icon src="assets/icons/files-content.svg" class="nav-icon" />
            <span *ngIf="!isSidebarCollapsed">Artifacts</span>
          </div>
          <svg-icon *ngIf="!isSidebarCollapsed" src="assets/icons/arrow-right.svg" class="nav-icon nav-icon-right" />
        </div>
      </div>

      <!-- Chat Sessions List (shown when no active tab or chats tab) -->
      <deo-ai-recent-starred-chat-section
        *ngIf="!isSidebarCollapsed"
        [starredSessions]="starredSessions"
        [recentSessions]="recentSessions"
        [agentRuns]="sidebarAgentRuns"
        [selectedRunId]="selectedRunId"
        [currentSessionId]="currentSessionId"
        [loadError]="chatSessionsLoadError"
        [isLoading]="isLoadingChatSessions"
        (chatSelected)="selectChat($event)"
        (runSelected$)="onRunSelected($event)"
        (chatDeleted$)="onChatDeleted($event)"
        (retry$)="loadChatSessionsAndInitialize()"
      ></deo-ai-recent-starred-chat-section>
    </div>
    <div class="right-panel">
      <!-- Main Chat Area -->
      <div class="chat-main">
        <!-- Welcome Screen (shown when no messages) -->
        <deo-ai-assistant-welcome-screen
          *ngIf="activeTab === 'welcome'"
          [userName]="userName"
          [(currentMessage)]="currentMessage"
          [selectedFile]="selectedFile"
          [isLoading]="isLoading"
          [isTyping]="isTyping"
          [isListening]="isListening"
          [beforeUpload]="beforeUpload"
          (send)="onWelcomeScreenSend($event)"
        ></deo-ai-assistant-welcome-screen>

        <!-- Existing Chat Interface (shown when messages exist) -->
        <deo-agent-runs-panel
          *ngIf="activeTab === 'chats' && isTalkingToAgent"
          [agent]="selectedAgent ?? null"
          [selectedRunId]="selectedRunId"
          (runSelected$)="onRunSelected($event)"
        ></deo-agent-runs-panel>
        <deo-ai-assistant-chats-view
          *ngIf="activeTab === 'chats' && !isTalkingToAgent"
          [allChats]="chatSessions"
          [currentSessionId]="currentSessionId"
          [isLoading]="isLoadingChatSessions"
          [loadError]="chatSessionsLoadError"
          (createNewChatRequested)="createNewChat()"
          (chatSelected)="selectChat($event)"
          (chatDeleted$)="onChatsDeleted($event)"
          (retry$)="loadChatSessionsAndInitialize()"
        ></deo-ai-assistant-chats-view>
        <deo-ai-assistant-existing-chat
          *ngIf="activeTab === 'one-chat'"
          [conversation]="currentConversation"
          [currentSessionId]="currentSessionId"
          [isArtifactDrawerOpen]="isArtifactDrawerVisible"
          [chatTitle]="currentChatTitle"
          [isFavorite]="isCurrentChatFavorite()"
          [answeringAgent]="answeringAgent"
          (favoriteChanged)="onCurrentChatFavoriteChanged($event)"
          (chatRenamed$)="onCurrentChatRenamed($event)"
          (chatDeleted$)="onChatDeleted($event)"
          (artifactsLoaded$)="onOpenChatArtifactsLoaded($event)"
        ></deo-ai-assistant-existing-chat>
        <!-- </ng-container> -->
        <div class="projects-area" *ngIf="activeTab === 'projects' && isProjectsVisible">
          <deo-projects (loadingChange)="onRightPanelLoadingChange($event)" (projectsDeleted$)="onProjectsDeleted($event)"></deo-projects>
        </div>
        <!-- An agent produces no artifacts, so the panel is stood down rather than showing DEO's under
             its name. Inactive, not destroyed: it keeps whatever it already loaded for DEO. -->
        <deo-panel-state
          *ngIf="activeTab === 'artifacts' && isTalkingToAgent"
          mode="empty"
          icon="assets/icons/files-content.svg"
          [title]="agentArtifactsEmptyTitle"
        ></deo-panel-state>
        <div class="artifacts-area" *ngIf="hasOpenedArtifactsTab" [hidden]="activeTab !== 'artifacts' || isTalkingToAgent">
          <deo-artifacts
            [isActive]="activeTab === 'artifacts' && !isTalkingToAgent"
            [refreshToken]="artifactsRefreshToken"
            (loadingChange)="onRightPanelLoadingChange($event)"
            (artifactsDeleted$)="onArtifactsDeleted($event)"
          ></deo-artifacts>
        </div>

        <div class="right-panel-loader" *ngIf="shouldShowRightPanelSpinner()">
          <gains-spinner></gains-spinner>
        </div>
      </div>
    </div>
  </div>
</div>

<deo-view-artifact-drawer></deo-view-artifact-drawer>
